export default __webpack_public_path__ + "static/media/CV_Tonje.8ab09535.pdf";